// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JP_z","textarea":"styles_textarea__17NQC"};